import styled from 'styled-components';
import { Modal, ModalTitle, ModalBody, ModalFooter } from 'design-system/src/components/Modal';
import { Typography } from 'design-system/src/components/Typography/Typography';
import Button from 'design-system/src/components/Button/Button';
import { EnrollmentInfoTable } from '../EnrollmentInfoTable';
import { PendingEnrollment } from '../../../types';

const SpacedContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export type CancelEnrollmentConfirmationModalProps = {
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
  enrollment: PendingEnrollment;
};

/**
 * Success modal after initiating an enrollment that does not require a signature.
 */
export const CancelEnrollmentConfirmationModal = ({
  onClose,
  onConfirm,
  isLoading,
  enrollment,
}: CancelEnrollmentConfirmationModalProps) => {
  return (
    <Modal onClose={onClose}>
      <ModalTitle>Cancel enrollment</ModalTitle>
      <ModalBody>
        <EnrollmentInfoTable enrollment={enrollment} />
        <SpacedContent>
          <Typography styledAs="bodyMediumDMSans">Are you sure you want to cancel this enrollment?</Typography>
          <Typography styledAs="bodyMediumDMSans">This action cannot be undone.</Typography>
        </SpacedContent>
      </ModalBody>
      <ModalFooter>
        <Button variant="secondary" onClick={onClose}>
          Back
        </Button>
        <Button variant="primary" onClick={onConfirm} isLoading={isLoading}>
          Cancel enrollment
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CancelEnrollmentConfirmationModal;
